import { HeadingBlock } from '@design-system/heading-block';
import { Typography } from '@design-system/typography';
import React, { FC } from 'react';

import { CardContentProps } from '../../models';
import { isReactChildrenValid } from '../../utils/isReactChildrenValid';
import CardMeta from '../card-meta/card-meta';

export const CardContent: FC<CardContentProps> = ({
  children,
  headingBlock,
  disclaimer,
  brandName,
  meta,
}) => (
  <div className="cds-card__content">
    <div className="cds-card__content-inner">
      {brandName && <span className="cds-card__brand-name">{brandName}</span>}
      <CardMeta meta={meta} />
      <HeadingBlock
        {...headingBlock}
        {...(headingBlock.headline && { title: headingBlock.headline })}
      />
      {isReactChildrenValid(children) || disclaimer ? (
        <div className="cds-card__content-bottom">
          {children}
          {disclaimer && (
            <Typography
              className="cds-card__disclaimer"
              variant="body"
              size="xs"
              tag="p"
              content={disclaimer}
              align={headingBlock?.align}
            />
          )}
        </div>
      ) : null}
    </div>
  </div>
);
